<h2 mat-dialog-title>{{dialogTitle}}</h2>
<div>
    <div>Are you sure you want to delete {{setting.name}}?</div>
    <br/><br/>
    <div class="text-center">


      <button class="badge bg-danger color-white" (click)="onSubmit()" type="submit" mat-button>Yes, Delete</button>&nbsp;
      <button mat-button mat-dialog-close>Cancel</button>
    </div>
  </div>
